import { render, staticRenderFns } from "./woyaohexiaoMsg.vue?vue&type=template&id=b7a83b54&scoped=true&"
import script from "./woyaohexiaoMsg.vue?vue&type=script&lang=js&"
export * from "./woyaohexiaoMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a83b54",
  null
  
)

component.options.__file = "woyaohexiaoMsg.vue"
export default component.exports